import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { Follow } from '../../Follow';
import { Page, PageTitle, Inner } from './partials';
export var ManagementCompanyHeader = function ManagementCompanyHeader(_ref) {
  var theme = _ref.theme,
    managementCompany = _ref.managementCompany,
    subscriptions = _ref.subscriptions,
    onFollow = _ref.onFollow;
  var organization = managementCompany.organization;
  var following = (subscriptions || []).includes(organization ? organization.id : null);
  var handleFollow = onFollow ? onFollow : function () {};
  return React.createElement(Inner, null, React.createElement(Page, {
    justify: "space-between"
  }, React.createElement(PageTitle, {
    as: theme.partner.headings.title,
    large: true
  }, managementCompany.name), React.createElement("div", null, false && theme.partner.user.actions && onFollow ? React.createElement(Fragment, null, organization ? React.createElement(Follow, {
    style: {
      marginLeft: '0'
    },
    following: following,
    follow: handleFollow,
    followers: organization.stats.subscribers
  }) : React.createElement(Follow, {
    style: {
      marginLeft: '0'
    },
    following: false,
    follow: function follow() {},
    followers: null,
    disabled: true
  })) : null)));
};
export default withTheme(ManagementCompanyHeader);